module.exports = __webpack_public_path__ + "static/media/view3.40dd3d2f.jpg";